import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { User } from 'dashboard/models/user';
import { dashboardApi } from 'dashboard/redux/api/api';
import { getAllUsers } from 'dashboard/redux/thunk-actions/user';
import { ApiEndpoint, ApiModel, ApiResponse } from 'lib/interfaces/api';

export const userApi = dashboardApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<ApiResponse<User>, string>({
      query: async (userId) =>
        await SessionClientDashboard.getResource<User>(ApiEndpoint.User, userId),
      providesTags: (result, _error, _id) =>
        result ? [{ type: ApiModel.User, id: result.data.id }] : [],
    }),
    listUsers: builder.query<User[], void>({
      query: getAllUsers,
    }),
  }),
});

// Hooks are autogenerated based on the defined endpoints
export const { useLazyGetUserQuery, useListUsersQuery } = userApi;
